import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Treatments from "./pages/Treatments";
import TreatmentDetail from "./pages/TreatmentDetail";
import Staff from "./pages/Staff";
import Contact from "./pages/Contact";
import DynamicPage from "./pages/DynamicPage";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

// Info Pages
import Gravide from "./pages/Gravide";
import BabyerBoern from "./pages/BabyerBoern";
import VoksenSenior from "./pages/VoksenSenior";
import PakkeforloebPage from "./pages/PakkeforloebPage";

export default function App() {
  return (
    <div className="flex min-h-screen flex-col bg-brand-50/30 antialiased">
      <ScrollToTop />
      
      {/* Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* Main Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/behandlinger" element={<Treatments />} />
          <Route path="/behandlinger/:slug" element={<TreatmentDetail />} />
          <Route path="/personale" element={<Staff />} />
          <Route path="/kontakt" element={<Contact />} />

          {/* Info Routes */}
          <Route path="/info/gravide" element={<Gravide />} />
          <Route path="/info/babyer" element={<BabyerBoern />} />
          <Route path="/info/voksen-og-senior" element={<VoksenSenior />} />
          <Route path="/info/pakkeforloeb" element={<PakkeforloebPage />} />

          {/* Error Pages */}
          <Route path="/404" element={<NotFound />} />
          <Route path="/403" element={<Forbidden />} />

          {/* Catch-all for other scraped pages (e.g. /praktisk, /kiropraktik, etc.) */}
          <Route path="/:slug" element={<DynamicPage />} />

          {/* Fallback to 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
